import { render } from "./goodsFloor.vue?vue&type=template&id=70fd8d65&scoped=true"
import script from "./goodsFloor.vue?vue&type=script&lang=js"
export * from "./goodsFloor.vue?vue&type=script&lang=js"

import "./goodsFloor.vue?vue&type=style&index=0&id=70fd8d65&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/FK-YF23001-01-生产-01-综合管理后台sznc_admin-前端构建部署/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fd8d65"]])

export default __exports__